import { GetRequest, PostRequestFile, PostRequest } from '../lib/request';

const GET_PROFILE = `/my-account/my-profile/api/get`;
const UPDATE_PROFILE = `/my-account/my-profile/api/update`


export async function GetProfile(){

        try{
            return await GetRequest(`${GET_PROFILE}`);
        }catch(ex){
            throw new Error("Unable to fetch the profile.");
        }
}

export async function UpdateProfile(data){

    try{
        return await PostRequest(`${UPDATE_PROFILE}`, data);
    }catch(ex){
        throw new Error("Unable to fetch the profile.");
    }
}